export const PAGE_TITLE = 'Booksy Biz'
export const DEFAULT_PAGE_DESCRIPTION = 'Frontdesk | Booksy'

export const HREF_LANG_LOCALE: string[] = [
  'x-default',
  'en-au',
  'en-ca',
  'en-gb',
  'en-ie',
  'en-us',
  'en-za',
  'en-cl',
  'es-co',
  'es-es',
  'es-mx',
  'es-us',
  'fr-fr',
  'pl-pl',
  'pt-br',
  'pt-pt',
  'uk-pl',
]

export const DEFAULT_LOCALE = 'en-us'
